import React, { createContext, useContext } from 'react';

import { useTable } from '../hooks/useTable';

export interface ITableContext<RowData extends object> extends ReturnType<typeof useTable<RowData>> {}

const TableContext = createContext<ITableContext<any>>(undefined!);
export interface ITableContextProviderProps<RowData extends object> {
    children: React.ReactNode;
    table: ReturnType<typeof useTable<RowData>>;
}
export const TableContextProvider = <RowData extends object>({
    children,
    table,
}: ITableContextProviderProps<RowData>) => {
    return (
        <TableContext.Provider
            value={{
                ...table,
            }}
        >
            {children}
        </TableContext.Provider>
    );
};

export const useTableContext = () => {
    const context = useContext(TableContext);
    if (!context) {
        throw new Error('useTableContext must be used within TableContextProvider');
    }

    return context;
};
